<template>
    <!-- S 侧边按钮 -->
    <div class="right-bar" :class="{curr: slideBar}">
        <div class="right-bar-item right-bar-item01">
            <svg class="daq-icon-symbol daq-icon tc" aria-hidden="true">
                <use xlink:href="#icondianhua"></use>
            </svg>
            <p class="name tc">服务热线</p>
            <div class="slide-bar">
                <div class="top">
                    <p class="title">咨询电话</p>
                    <p class="tel">028-85367797 / 400-028-0035</p>
                </div>
                <div class="bottom">工作日 9:00 ~ 18:00</div>
            </div>
        </div>
        <div class="right-bar-item right-bar-item03 tc" @click="goBack">
            <svg class="daq-icon-symbol daq-icon" aria-hidden="true">
                <use xlink:href="#iconjiantou-xia-copy"></use>
            </svg>
            <p class="name">返回顶部</p>
        </div>
    </div>
    <!-- E 侧边按钮 -->
</template>
<script>
    export default {
        data (){
             return {
                slideBar: false, // 侧边栏
            }
        },
        mounted () {
            window.addEventListener("scroll", this.handleScroll, false);
        },
        methods:{
            // 选项卡滚动事件
            handleScroll() {
                let top = document.documentElement.scrollTop
                if (top > 500) {
                    this.slideBar = true
                } else {
                    this.slideBar = false
                }
            },
            // 回到顶部
            goBack(){
                $("body,html").stop(true).animate({scrollTop:0},500);
            }
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>
<style lang="scss" scoped>
.right-bar{
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 9;
    width: 0;
    height: 170px;
    margin: -40px 0 0;
    transition: all .4s linear;
    &-item{
        position: relative;
        width: 72px;
        height: 72px;
        background: rgba(2,9,20,.6);
        border-radius: 5px;
        margin-top: 10px;
        padding-top: 1px;
        cursor: pointer;
        .daq-icon{
            margin: 10px auto 5px;
            display: block;
        }
        .daq-icon,
        .name{
            color: $fc10;
        }
        &:hover{
            background: $bg01;
        }
        .slide-bar{
            position: absolute;
            top: 0;
            right: 82px;
            width: 240px;
            height: 146px;
            background: #f3f3f3;
            box-shadow: 0 0 10px rgba(11,3,6,.1);
            transition: all .4s linear;
            display: none;
            .top{
                height: 106px;
                background: $bg02;
                font-weight: bold;
                padding-left: 20px;
                .title{
                    color: $fc03;
                    font-size: $f16;
                    padding: 30px 0 20px;
                }
                .tel{
                    color: $fc01;
                    font-size: 13px;
                }
            }
            .bottom{
                color: $fc04;
                padding-left: 20px;
                line-height: 40px;
            }
        }
    }
    &-item01{
        .daq-icon{
            font-size: $f34;
        }
        &:hover{
            .slide-bar{
                display: block;
            }
        }
    }
}
.curr{
    width: 72px;
    right: 15px;
}
</style>
